import { Checkbox, Select, Option } from "@material-tailwind/react";
import { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const MultiSelect = ({
  name,
  options,
  value,
  onChange,
  error = false,
  placeholder = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [newOption, setNewOption] = useState("");
  const [internalOptions, setInternalOptions] = useState(options || []);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setInternalOptions(options || []);
  }, [options]);

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const handleAddOption = (e) => {
    e.preventDefault();
    if (
      newOption &&
      !internalOptions.some(
        (opt) => opt.value === newOption || opt === newOption
      )
    ) {
      const newOpt =
        options && options[0] && typeof options[0] === "object"
          ? { value: newOption, count: 0 }
          : newOption;
      setInternalOptions((prev) => [...prev, newOpt]);
      onChange(newOpt.valueOf || newOpt);
      setNewOption("");
      setIsOpen(false);
    }
  };

  // For display, support both array of string or array of {value}
  const displayOptions = internalOptions.map((opt) =>
    typeof opt === "object" ? opt.value : opt
  );

  return (
    <div className="w-full" ref={dropdownRef}>
      <div className="relative">
        {/* Dropdown Button */}
        <button
          type="button"
          onClick={handleToggle}
          className={`flex justify-between items-center w-full bg-white/70 border rounded-md shadow-sm px-4 py-2 text-left text-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-gray-900 focus:border-gray-900
            [@media(min-height:1400px)]:!h-20 [@media(min-height:1400px)]:!text-2xl
            ${
              error
                ? "!border-red-500 focus:!border-red-900"
                : "border-blue-gray-200"
            }
          `}
        >
          {value
            ? typeof value === "object"
              ? value.value
              : value
            : placeholder || `เลือก${name}`}
          <ChevronDownIcon
            strokeWidth={2.5}
            className={`h-3.5 w-3.5 transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </button>
        {error && (
          <div className="text-red-500 text-xs mt-1 px-1">กรุณาเลือก{name}</div>
        )}

        {/* Dropdown Options */}
        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white border border-blue-gray-200 rounded-lg shadow-lg max-h-72 overflow-y-auto">
            <ul>
              {displayOptions.map((option) => {
                const isSelected =
                  (typeof value === "object" ? value.value : value) === option;
                return (
                  <li
                    key={option}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer [@media(min-height:1400px)]:!text-2xl [@media(min-height:1400px)]:!h-20 flex items-center"
                    onClick={() => handleSelect(option)}
                  >
                    <Checkbox
                      className="size-4 [@media(min-height:1400px)]:!size-6"
                      labelProps={{ className: "whitespace-nowrap" }}
                      checked={isSelected}
                      readOnly
                    />
                    {option}
                  </li>
                );
              })}
            </ul>
            <div className="flex items-center px-4 py-2 border-t">
              <input
                type="text"
                value={newOption}
                onChange={(e) => setNewOption(e.target.value)}
                className="w-full border border-blue-gray-200 rounded-lg px-2 py-1"
                placeholder={`เพิ่ม${name}ใหม่`}
              />
              <button
                type="button"
                onClick={handleAddOption}
                className="ml-2 bg-primary text-white px-4 py-1 rounded-lg"
              >
                +
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelect;
